import { makeAutoObservable } from 'mobx';

export default class AddLabelStore {
    onAddLabel: ((labelId: number) => void) | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    open(onAddLabel: (labelId: number) => void) {
        this.onAddLabel = onAddLabel;
    }

    addLabel(labelId: number) {
        this.onAddLabel!(labelId);
        this.onAddLabel = null;
    }

    close() {
        this.onAddLabel = null;
    }

    isOpen(): boolean {
        return !!this.onAddLabel;
    }

    clear() {
        this.onAddLabel = null;
    }
}
